<template>
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M27.678 7.71643C26.1244 5.12708 22.3717 5.12707 20.8181 7.71643L3.88285 35.9418C2.28319 38.6079 4.20364 41.9998 7.31282 41.9998H41.1833C44.2925 41.9998 46.2129 38.6079 44.6133 35.9418L27.678 7.71643Z"
      fill="url(#paint0_linear_2857_9430)"
    />
    <path
      d="M23.2058 31.4318L20.5745 19.7945C19.7364 15.2592 26.2198 13.8145 27.417 18.275C27.5315 18.7858 27.5237 19.3146 27.417 19.7945L24.7857 31.4318C24.6035 32.2599 23.3854 32.2522 23.2058 31.4318Z"
      fill="white"
    />
    <path
      d="M24 38.9999C25.3807 38.9999 26.5 37.8905 26.5 36.5219C26.5 35.1534 25.3807 34.0439 24 34.0439C22.6193 34.0439 21.5 35.1534 21.5 36.5219C21.5 37.8905 22.6193 38.9999 24 38.9999Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2857_9430"
        x1="3.30664"
        y1="23.8871"
        x2="45.1557"
        y2="22.6987"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#5A6698" />
        <stop offset="1" stop-color="#3A497A" />
      </linearGradient>
    </defs>
  </svg>
</template>
